import { isValid } from "date-fns";
import { validateRegex } from './RegexValidator/validator.js';
import DOMPurify from 'dompurify';
import JSZip from "jszip";
import { saveAs } from "file-saver";
// import ShortUniqueId from 'short-unique-id';
import uuid from "react-uuid";
import { functions } from "../components/IFormDesignerLayout/ApplicationAPI/applicationApi.js";
import { getFormJsonFromStore } from "../components/IFormDesignerLayout/IFormDesignerLogic.jsx";

// to find all the sections in form
// document.querySelectorAll('div[elem_type="frame"]');

// to find all sections/ frame inside a tab
// document.querySelector("#tab4").querySelectorAll('div[elem_type="frame"]');


export function getEncKey_gcm() {
  // defining key 

 var keyarr=[];
  keyarr[0]= "\u0075";
  keyarr[1]= "\u0073";
  keyarr[2]= "\u0065";
  keyarr[3]= "\u0072";
  keyarr[4]= "\u005F";
  keyarr[5]= "\u0073";
  keyarr[6]= "\u0065";
  keyarr[7]= "\u0063";
  keyarr[8]= "\u0072";
  keyarr[9]= "\u0065";
  keyarr[10]= "\u0074";
  keyarr[11]= "\u005F";
  keyarr[12]= "\u006B";
  keyarr[13]= "\u0065";
  keyarr[14]= "\u0079";
  keyarr[15]= "\u005F";

   var key = keyarr.join("");
 return key;
}

export function getEncivf_gcm() {
 // defining key 

 var ivfarr=[];
  ivfarr[0]= "\u0052";
  ivfarr[1]= "\u0061";
  ivfarr[2]= "\u006E";
  ivfarr[3]= "\u0064";
  ivfarr[4]= "\u006F";
  ivfarr[5]= "\u006D";
  ivfarr[6]= "\u0049";
  ivfarr[7]= "\u006E";
  ivfarr[8]= "\u0069";
  ivfarr[9]= "\u0074";
  ivfarr[10]= "\u0056";
  ivfarr[11]= "\u0065";
  ivfarr[12]= "\u0063";
  ivfarr[13]= "\u0074";
  ivfarr[14]= "\u006F";
  ivfarr[15]= "\u0072";

   var ivf =ivfarr.join("");

   return ivf;
}

export function capitalizeFirstLetter(string) {
  if (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}
export function downloadButtonJson(jsonData, fileName) {
  const zip = new JSZip();

  const Json = JSON.stringify(jsonData);
  const newJson = Json.replaceAll("\"", "\"");
  const finalJson = JSON.stringify({ "formBuffer": newJson })
  zip.file(`${fileName}.json`, finalJson)
  zip.generateAsync({ type: "blob" }).then(function (content) {
    // see FileSaver.js
    saveAs(content, `${fileName}.zip`);
  });
  // const file=new Blob([Json],{type:'application/json'});
  const href = URL.createObjectURL(zip);
  const link = document.createElement("a");
  // var zipName = 'download.zip';
  link.href = href;
  // link.download=`${fileName}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
export function downloadJson(jsonData, fileName) {
  const Json = JSON.stringify(jsonData);
  const file = new Blob([Json], { type: 'application/json' });
  const href = URL.createObjectURL(file);
  const link = document.createElement("a");
  link.href = href;
  link.download = `${fileName}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function isColor(strColor) {
  if (strColor) {
    var s = new Option().style;
    s.color = strColor;
    var test1 = s.color == strColor;
    var test2 = /^#[0-9A-F]{6}$/i.test(strColor);
    var test3 = /^#[0-9A-F]{8}$/i.test(strColor);
    var test4 = /^#[0-9A-F]{3}$/i.test(strColor);
    if (test1 == true || test2 == true || test3 === true || test4 === true) {
      return strColor;
    }
    else {
      var color3 = `#${strColor}`;
      var s2 = new Option().style;
      s2.color = color3;
      var test5 = s2.color == color3;
      var test6 = /^#[0-9A-F]{6}$/i.test(color3);
      var test7 = /^#[0-9A-F]{8}$/i.test(color3);
      var test8 = /^#[0-9A-F]{3}$/i.test(color3);

      if (test5 == true || test6 == true || test7 === true || test8 === true) {
        return color3;
      }
      else {
        return "";
      }
    }
  }
}

export function hexToRgb(hex) {

  if (/^#([0-9A-F]{3}){1,2}$/i.test(hex)) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }
  if (/^#([0-9A-F]{8})$/i.test(hex)) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16),
      c: parseInt(result[4], 16)
    } : null;
  }
}

// export function rgba2hex(color) {
//   if (/^rgb/.test(color)) {
//     const rgba = color.replace(/^rgba?\(|\s+|\)$/g, '').split(',');

//     // rgb to hex
//     // eslint-disable-next-line no-bitwise
//     let hex = `#${((1 << 24) + (parseInt(rgba[0], 10) << 16) + (parseInt(rgba[1], 10) << 8) + parseInt(rgba[2], 10))
//       .toString(16)
//       .slice(1)}`;

//     // added alpha param if exists
//     if (rgba[4]) {
//       const alpha = Math.round(0o1 * 255);
//       const hexAlpha = (alpha + 0x10000).toString(16).substr(-2).toUpperCase();
//       hex += hexAlpha;
//     }

//     return hex;
//   }
//   return color;
// };


export function validateHexColor(hex) {
  return /^#([0-9A-F]{3}){1,2}$/i.test(hex) || /^#[0-9A-F]{8}$/i.test(hex)
}


export function checkValid_wiz(value) {
  if (value === undefined || value === null || value === "" || value === [] || value === {} || value.length === undefined || value.length === 0 || isObjectEmpty(value) || value !== 0) {
    return false;
  } else {
    return value
  }
}

export function checkValid(value) {
  if (value === undefined || value === null || value === "" || value === [] || value === {} || value.length === undefined || value.length === 0 || isObjectEmpty(value) ) {
    return false;
  } else {
    return value
  }
}

export function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}

export function getNumber(value) {
  if (value) {
    return parseInt(value.replace(/\D/gm, ""))
  }
}

export function getSpacingValue(value) {
  if (value && typeof value === "string" && value.endsWith("pt")) {
    const ptValue = parseFloat(value);
    if (!isNaN(ptValue)) {
      return `${parseFloat((ptValue * (96 / 72)).toFixed(2))}px`;
    }
  }
  return value;
}

export function regexValidator(propertyValue, propertyRegexType) {
  if (propertyValue.trim().length === 0)
    return true;
  else if (propertyValue && propertyRegexType) {
    // let str = propertyValue.toString();
    // const ascii = /^[ A-Za-z0-9_@./#&+-!"'$^%*()={[}\\];:,\/\\-`~]*$/;
    // if (ascii.test(propertyValue)) {
      // string has non-ascii characters
      return validateRegex(propertyValue, propertyRegexType);
    // }
  }
  return false;
}

export function sanitizeJson(jsonToSanitize) {
  return JSON.parse(JSON.stringify(jsonToSanitize));
  // return JSON.parse(DOMPurify.sanitize(JSON.stringify(jsonToSanitize)))
}

export function sanitizeStringToJson(StringToSanitize) {
  return JSON.parse(StringToSanitize)
  // return JSON.parse(DOMPurify.sanitize(StringToSanitize))

}

export function sanitizeStringToString(StringToSanitize) {
  return StringToSanitize
  // return DOMPurify.sanitize(StringToSanitize)
}

export const toHtmlEntities = (str) => {
  return str.replace(/./gm, function (s) {
    return (s.match(/[a-z0-9\s]+/i)) ? s : "&#" + s.charCodeAt(0) + ";";
  });
}

export const fromHtmlEntities = (str) => {
  return (str + "")?.replace(/&#\d+;/gm, function (s) {
    return String.fromCharCode(s?.match(/\d+/gm)[0]);
  })
}

export const callZoneGotFocusWithPreHook = ({ selected, controlId }) => {
  try {
    let zLeft = selected[0].Left;
    let zTop = selected[0].Top;
    let finalWidth = selected[0].Left + selected[0].Width;
    let finalHeight = selected[0].Top + selected[0].Height;
    const zoneName = selected[0].name;
    const eleJSON = functions.readJson(getFormJsonFromStore(), controlId);
    if (window.preHookZoneGotFocus) {
      const arrOfValues = window.preHookZoneGotFocus(zoneName, zLeft, zTop, finalWidth, finalHeight, getHooksId(eleJSON)) || [];
      zLeft = arrOfValues[0];
      zTop = arrOfValues[1];
      finalWidth = arrOfValues[2];
      finalHeight = arrOfValues[3];
      functions.updateJSON();
    }

    window.ZoneGotFocus(zLeft, zTop, finalWidth, finalHeight, zoneName);
  }
  catch (err) {
    console.log("Exception in callZoneGotFocusWithPreHook", err)
  }
}

const getUniqueId = (elem_type) => {
  // const uid = new ShortUniqueId();
  // uid.setDictionary('alphanum')
  // return `${elem_type}${uid(10)}`;
  return `${elem_type}${uuid().slice(-8)}`;
}

export const replaceElementsId = (formState) => {
  if (formState?.children) {
      for(let i=0; i<formState.children.length;i++){
          if (formState.children[i].elem_type === "column") {
            formState.children[i].id = getUniqueId("column");
          }
          else if (formState.children[i].elem_type === "row") {
            formState.children[i].id = getUniqueId("row");
            replaceElementsId(formState.children[i]);
          }
          else if(formState.children[i].subform && formState.children[i].elem_type === "button") {
              replaceElementsId(formState.children[i].subform);
          }
          else if(formState.children[i].listviewFrameLayoutJson && formState.children[i].elem_type === "advancelistView") {
              replaceElementsId(formState.children[i].listviewFrameLayoutJson);
          }
          else {
              replaceElementsId(formState.children[i]);
          }
      }
  }
  return formState;
}

window.changeId = replaceElementsId;

export function getFocusableElement(element ){
  var focusable = element?.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  return focusable; 
}

export function focusElement( elem ,pos =0 ){
  const focusElems = getFocusableElement( elem );
  if( focusElems && focusElems[pos]){
    focusElems[pos].focus();
  }
}

export function trapFocus(elem){
    const focusElems =getFocusableElement( elem );
  
    var isFocused = false;

    if(focusElems){

      for(var i=0; i < focusElems?.length ; i++ ){
        if(focusElems[i] === document.activeElement){
          isFocused = true;
          return;
        }
      }
  
      if(isFocused===false){
        focusElement(elem , 0);
      }
    }
}

export function isfocusedInside(elem){
  const focusElems =getFocusableElement( elem );

  var isFocused = false;

  if(focusElems){
    
    for(var i=0; i < focusElems?.length ; i++ ){
      if(focusElems[i] === document.activeElement){
        isFocused = true;
        return true;
      }
    }
  }

  return isFocused;

}

export function handleFocus(id) {
  const addRecordBtnToFocus = document.getElementById(id);
  if(addRecordBtnToFocus) {
    addRecordBtnToFocus.focus();
  }
}

export function checkEmpty(formdata){
  if(formdata?.children?.[1]?.id==="RootControl"){
      if(formdata?.children?.[1]?.children?.length===0 ){
          return true
      }
      if(formdata?.children?.[1]?.children?.length===1 && formdata?.children?.[1]?.children?.[0]?.id==="Event" ){
          return true
      }
      else if(formdata?.children?.[1]?.children?.length>1){
          return false
      }
  }
  else{
      return false
  }
}

export const dragAndDropThroughMDM = (currentDataObjectJson,controlElemToAdd1) =>{
  if(currentDataObjectJson && (currentDataObjectJson["VariableName"] || currentDataObjectJson["treeName"])){
    controlElemToAdd1.style["custom_picklist_data"] = currentDataObjectJson?.custom_picklist_data
    controlElemToAdd1.style["Mandatory"] = currentDataObjectJson?.mandatory === "1" ? "true" : controlElemToAdd1?.style?.["Mandatory"] || "false"
    controlElemToAdd1.style["Visible"] = currentDataObjectJson?.hidden === "1" ? "false" : controlElemToAdd1?.style?.["Visible"] || "true"
    controlElemToAdd1.style["Enable"] = currentDataObjectJson?.non_modifiable === "1" ? "false" : controlElemToAdd1?.style?.["Enable"] || "true"
    controlElemToAdd1.style["previousEnable"] = currentDataObjectJson?.non_modifiable === "1" ? "false" : controlElemToAdd1?.style?.["previousEnable"] || "true"
    controlElemToAdd1.style["ReadOnly"] = currentDataObjectJson?.read_only === "1" ? "true" : controlElemToAdd1?.style?.["ReadOnly"] || "false"
    controlElemToAdd1.style["previousReadOnlyValue"] = currentDataObjectJson?.read_only === "1" ? "true" : controlElemToAdd1?.style?.["previousReadOnlyValue"] || "false"
    // controlElemToAdd1.style["SortingType"] = currentDataObjectJson?.allow_sorting === "1" ? "true" :controlElemToAdd1?.style?.["SortingType"] || "false"
    controlElemToAdd1.style["DefaultSorting"]=currentDataObjectJson?.allow_sorting==="1"? "asc": controlElemToAdd1.style?.["DefaultSorting"] || "none"
    const isMaskedActive = currentDataObjectJson?.IsMasked === true || currentDataObjectJson?.IsMasked === "true";
    controlElemToAdd1.style["MaskingValue"] = ((currentDataObjectJson?.masking && currentDataObjectJson?.masking?.mask_enabled) || (isMaskedActive && currentDataObjectJson?.MaskingPattern)) ? "MaskingFromMDM" : (controlElemToAdd1.style["MaskingValue"] !== "MaskingFromMDM" ? controlElemToAdd1.style["MaskingValue"] : "Select")
    if (currentDataObjectJson?.masking) {
      controlElemToAdd1.style["masking"] = currentDataObjectJson?.masking;
      if (controlElemToAdd1?.elem_type === "textbox") {
        delete controlElemToAdd1.style["CharacterSet"]
        delete controlElemToAdd1.style["CustomPattern"]
        delete controlElemToAdd1.style["MaxLength"]
        delete controlElemToAdd1.style["MaxValue"]
        delete controlElemToAdd1.style["MinValue"]
      }
    }
    if (currentDataObjectJson?.MaskingPattern) {
      controlElemToAdd1.style["masking"] = typeof currentDataObjectJson.MaskingPattern === "string" ? JSON.parse(currentDataObjectJson.MaskingPattern) : currentDataObjectJson.MaskingPattern;
      if (controlElemToAdd1?.elem_type === "textbox") {
        delete controlElemToAdd1.style["CharacterSet"]
        delete controlElemToAdd1.style["CustomPattern"]
        delete controlElemToAdd1.style["MaxLength"]
        delete controlElemToAdd1.style["MaxValue"]
        delete controlElemToAdd1.style["MinValue"]
      }
    }      
  }
  return controlElemToAdd1
}

export const getHooksId = (data, ref) => {
  const isIBPSClient = window?.psh_configs?.isIBPSClient || false;
  let dataClass = data.dataclass
  if (isIBPSClient && dataClass) {
    dataClass = dataClass?.replaceAll(".", "_");
  }    
  if (window?.psh_configs && window?.psh_configs?.hooksIdentifierKey) {
    const key = window?.psh_configs.hooksIdentifierKey;
    if (key === "defaultId") {
      if(ref?.id && ref?.id !== data?.id) {
        return ref?.id;
      }
      return data?.id;
    } else if (key === "customId") {
      return data?.style?.CustomId || dataClass || data?.id;
    } else if (key === "dataClass") {
      return dataClass || data?.id;
    }
  }
  return data?.id;
}
  